export default {
	input: '$black',
	'input-bg': '$custom03',
	'input-shadow': '$grey07',

	'input-placeholder': '$grey09',
	'input-focus-shadow': '$primary07',

	// 'animated-input-wrapper-shadow': '$grey02',
	// 'animated-input-wrapper-focus-border': '$primary07',
	'animated-select-ul-bg': '$white',
	'animated-input-label': '$grey08',

	'input-disabled': '$grey10',
	'input-disabled-bg': '$custom00',
	'input-disabled-placeholder': '$grey12',

	'input-read-only-bg': '$custom27',
	'input-read-only-shadow': '$custom27',

	'input-ghost-focus-bg': '$white',
	'input-ghost-focus-shadow': '$purple08',

	'input-invalid-shadow': '$red07',
	'input-invalid-focus-shadow': '$red08',

	'input-valid-shadow': '$primary07',
	'input-valid-focus-shadow': '$primary08',

	textarea: '$black',
	'textarea-bg': '$white',
	'textarea-shadow': '$grey07',

	'textarea-focus-shadow': '$purple08',
	'textarea-placeholder': '$grey09',

	'textarea-disabled': '$grey08',
	'textarea-disabled-bg': '$grey02',
	'textarea-disabled-placeholder': '$grey07',

	'textarea-read-only-bg': '$grey02',
	'textarea-read-only-foucs-shadow': '$grey07',

	'textarea-invalid-shadow': '$red07',
	'textarea-invalid-focus-shadow': '$red08',

	'textarea-valid-shadow': '$primary07',
	'textarea-valid-focus-shadow': '$primary08',
}
